import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// import custom style
import '@/assets/style/swiper.min.css';
// import "swiper/swiper.min.css";

Vue.use(VueAwesomeSwiper);